import { render, staticRenderFns } from "./SuppliersCarousel.vue?vue&type=template&id=1b54a0e4&"
import script from "./SuppliersCarousel.vue?vue&type=script&lang=js&"
export * from "./SuppliersCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersCarousel.vue?vue&type=style&index=0&id=1b54a0e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports